export default [
    {
		path: "/feedback/",
		component: () => import("../views/Feedback/Home.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/feedback/new/:userid",
		component: () => import("../views/Feedback/Item.vue"),
	},
	{
		path: "/feedback/studentfeedback",
		component: () => import("../views/Feedback/StudentFeedback/Home.vue"),
	},
	{
		path: "/feedback/list/:userid",
		component: () => import("../views/Feedback/ListStudent.vue"),
	},
]
